// Events
import { MODAL_CLOSE, MODAL_OPEN, VIDEO_PLAY, VIDEO_STOP } from 'events';
import { component } from 'picoapp';
import Swiper, { A11y, Autoplay, Manipulation, Mousewheel, Navigation, Scrollbar } from 'swiper';

// Utils
import choozy from 'utils/choozy';
import { hide, show } from 'utils/node';
import { dispatch } from 'utils/theme';

Swiper.use([A11y, Autoplay, Navigation, Manipulation, Mousewheel, Scrollbar]);

const MEDIA_TYPE_VIDEO = 'video';

export default component((node, ctx) => {
  const { slider, progressIndicator, thumbnail, progressBar, thumbsBar, slide } = choozy(node);

  const { modalId } = node.dataset;

  const progressIndicators = [].concat(progressIndicator);
  const slides = [].concat(slide);
  const thumbnails = [].concat(thumbnail);
  const videoSlides = slides.filter(
    (slideElement) => slideElement.dataset.slideType === MEDIA_TYPE_VIDEO,
  );

  const playVideoSlide = (activeSlide) => {
    const slideElement = slides.find((currentSlide) => +currentSlide.dataset.slide === activeSlide);

    if (slideElement?.dataset.slideType !== MEDIA_TYPE_VIDEO) return;

    ctx.emit(VIDEO_PLAY, null, slideElement.dataset.slideMediaId);
  };

  const stopVideos = () => {
    videoSlides.forEach((slideElement) => {
      ctx.emit(VIDEO_STOP, null, slideElement.dataset.slideMediaId);
    });
  };

  const carousel = new Swiper(slider, {
    slidesPerView: '1',
    speed: 200,
    spaceBetween: 10,
    breakpoints: {
      1024: {
        speed: 1300,
      },
    },
  });

  const thumbsCarousel = new Swiper(thumbsBar, {
    slidesPerView: 8,
    direction: 'vertical',
    spaceBetween: 8,
  });

  const handleKeyPress = (e) => {
    switch (e.key) {
      case 'ArrowLeft':
        carousel.slidePrev();
        break;
      case 'ArrowRight':
        carousel.slideNext();
        break;
      case 'Escape':
        ctx.emit(MODAL_CLOSE, null, { id: modalId });
        break;
      default:
        break;
    }
  };

  carousel.on('slideChange', ({ activeIndex }) => {
    stopVideos();

    thumbsCarousel.slideTo(activeIndex);

    [...thumbnails, ...progressIndicators].forEach((el) => {
      el.classList[+el.dataset.slideRef === activeIndex ? 'add' : 'remove']('active');
    });

    dispatch('pdp-change-main-image', { index: activeIndex, overlay: true });
  });

  [...thumbnails, ...progressIndicators].forEach((el) => {
    el.addEventListener('click', () => {
      carousel.slideTo(+el.dataset.slideRef, 1300);
    });
  });

  slider.addEventListener('zoom:start', (e) => {
    e.stopPropagation();

    carousel.disable();
  });

  slider.addEventListener('zoom:end', (e) => {
    e.stopPropagation();
    carousel.enable();
  });

  node.addEventListener('video:play', () => {
    hide(progressBar, thumbsBar);
  });

  node.addEventListener('video:ended', () => {
    show(progressBar, thumbsBar);
  });

  ctx.on(MODAL_OPEN, (state, { id, props }) => {
    if (id !== modalId) return;

    const { activeSlide } = props;

    carousel.slideTo(activeSlide, 0);

    if (props.autoplayVideo) {
      playVideoSlide(activeSlide);
    }

    window.addEventListener('keydown', handleKeyPress);
  });

  ctx.on(MODAL_CLOSE, (state, { id }) => {
    if (id !== modalId) return;

    stopVideos();

    window.removeEventListener('keydown', handleKeyPress);
  });
});
